import { render } from "./CaseItems.vue?vue&type=template&id=009496b1&scoped=true&ts=true"
import script from "./CaseItems.vue?vue&type=script&lang=ts"
export * from "./CaseItems.vue?vue&type=script&lang=ts"

import "./CaseItems.vue?vue&type=style&index=0&id=009496b1&lang=css"
import "./CaseItems.vue?vue&type=style&index=1&id=009496b1&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\TTI.AVE.Web\\Vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-009496b1"]])

export default __exports__